'use strict';

angular.module('amexReconciliationApp')
  .component('accountingFieldInput', {
    templateUrl: 'scripts/views/components/accounting-field-input.html',
    bindings: {
      schema: '<',
      accountingFieldDisabled: '<',
      field: '<',
      validationSuccessful: '=',
      refreshMaskValidationErrorsCount: '&',
      updateAllocationsValidity: '&',
      clearLowerComboValues: '&',
      allocationIndex: '<',
      allocation: '<',
      displayLoadingMessageFlag: '=',
      isFocused: '=',
      inputId: '@'
    },
    controller: function ($element,
                          $timeout,
                          SiteConfigModel,
                          AccountingFieldAutocompleterFactory,
                          AccountingCodeValueRepository,
                          MaskFormatterService) {
      var self = this;
      var ngModel;

      self.$onInit = function () {
        var input = $element.find('input');
        ngModel = input.controller('ngModel');

      var inputId = document.querySelectorAll('.scrollable-dropdown-menu input');

          angular.element(inputId).ready(function() {
              angular.element(inputId).removeAttr('aria-expanded');
              angular.element(inputId).removeAttr('aria-owns');
          });

        self.validationSuccessful = true;
        self.isFocused = false;
        self.isHover = false;
        self.cancelBlurCallback = true;
        self.description = null;
        self.displayLoadingMessageFlag = false;

        self.autocompleter = AccountingFieldAutocompleterFactory.create({
          companyId: SiteConfigModel.companyId(),
          siteNumber: SiteConfigModel.siteNumber(),
          schema: self.schema,
          allocation: self.allocation
        });
      };

      self.$postLink = function () {
        var input = $element.find('input');
        ngModel = input.controller('ngModel');

        if (self.schema.maskPattern) {

          ngModel.$parsers.push(function (value) {

            var parsed = MaskFormatterService.stripDelimiters(value, self.schema);
            self.validationSuccessful = MaskFormatterService.validateMask(value,self.schema);
            updateMaskValidationErrorCount(self.validationSuccessful);
            
            return parsed;
          });

          ngModel.$formatters.push(function (value) {

            var formatted = MaskFormatterService.formatForDisplay(value, self.schema);
            self.validationSuccessful = MaskFormatterService.validateMask(formatted,self.schema);
            updateMaskValidationErrorCount(self.validationSuccessful);

            return formatted;
          });
        }
      };

      self.onAutocompleteValueSelected = function (model) {
        ngModel.$setDirty();
        if (self.schema.maskPattern) {
          self.field.value = MaskFormatterService.stripDelimiters(model, self.schema);
        } else {
          self.field.value = model;
        }
      };

      self.suggestedValues = function (search) {
        var linkedComboStrings = getLinkedComboFieldStrings();
        var searchParameters = {
          phrase: search,
          comboPositions: linkedComboStrings.positions,
          comboValues: linkedComboStrings.values
        };
        if (linkedComboStrings.positions !== 'start,end') {
          self.autocompleter.clear();
        }
        return self.autocompleter.search(searchParameters);
      };

      self.loadDescription = function() {
        self.description = null;
        self.isHover = true;
        var parameters = {
          companyId: SiteConfigModel.companyId(),
          siteNumber: SiteConfigModel.siteNumber(),
          schema: self.schema,
          searchString: self.field.value.toUpperCase()
        };

        AccountingCodeValueRepository.getDescription(parameters)
          .then(function(description) {
            if(description.length > 0) {
              self.description = description[0];
            }else{
              self.description = null;
            }
          });

      };

      self.showTooltip = function() {
        return !self.isFocused && self.isHover && self.description;
      };

      self.mouseLeave = function() {
        self.isHover = false;
      };

      self.displayPopover = function() {
        return self.field.value === '' && self.schema.validationIndicator !== 'N';
      };
      
      self.change = function () {
        self.clearLowerComboValues({index: self.allocationIndex,position: self.field.position});
      };

      self.focus = function () {
        self.isFocused = true;
        if (self.field.value === '') {
          self.clearLowerComboValues({index: self.allocationIndex,position: self.field.position});
        }
        updateMaskValidationErrorCount(self.validationSuccessful);
      };

      self.blur = function () {
        self.isFocused = false;
        self.cancelBlurCallback = false;
        $timeout(blurCallBack,200);
      };
      
      function blurCallBack() {
        if (!self.cancelBlurCallback) {
          updateMaskValidationErrorCount(self.validationSuccessful);
        }
      }

      function updateMaskValidationErrorCount(currentValidationState) {
        self.updateAllocationsValidity({index: self.allocationIndex,position: self.field.position,invalid: !currentValidationState, isFocused: self.isFocused});
        self.refreshMaskValidationErrorsCount();
        self.cancelBlurCallback = true;
      }

      function getLinkedComboFieldValues() {
        var schemas = SiteConfigModel.getAccountingFieldSchemas();
        var linkedComboFields = [];
        if (self.schema.validationComboId !== 0) {
          linkedComboFields = _.map(_.filter(schemas, function(o) {
            return (o.validationComboId === self.schema.validationComboId &&
            o.displayIndex < self.schema.displayIndex);
          }), function(filteredSchema) {
            return {
              position: _.get(filteredSchema, 'validationComboPosition', 0),
              value: _.get(_.find(self.allocation.accountingFieldValues, ['position', filteredSchema.position]), 'value', '')
            };
          });
        }
        return linkedComboFields;
      }

      function getLinkedComboFieldStrings() {
        var linkedComboFields = getLinkedComboFieldValues();
        var positions = 'start,';
        var values = 'start,';
        _.forEach(linkedComboFields, function(o) {
          positions += o.position.toString() + ',';
          values += o.value + ',';
        });
        return {positions: positions+'end', values: values+'end'};
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/accountingFieldInput.js
// module id = 426
// module chunks = 0